angular.module('impactx.customerservice').controller('CustomerServicePanelCtrl', [
    'CustomerService',
    'ToastService',
    CustomerServicePanelController
]);

function CustomerServicePanelController(CustomerService, ToastService) {
    var self = this;
    self.minimized = false;
    self.maximized = false;

    CustomerService.getDialogData().then(function (result) {
        self.data = result.data;
        self.trns = result.trns;
    });

    self.sendCustomerServiceMessage = function () {
        CustomerService.send(self.data).then(function () {
            ToastService.openStandardToast(self.trns.saveSuccess);
            CustomerService.closePanel();
        })
    };

    self.toggleMinimize = function () {
        self.minimized = !self.minimized;
        if (self.minimized) {
            self.maximized = false;
        }
    };

    self.toggleMaximize = function () {
        self.maximized = !self.maximized;
        if(self.maximized) {
            self.minimized = false;
        }
    };

    self.close = function () {
        CustomerService.closePanel();
    };
}
